import {
  MainPhotoSection,
  WebTerminalSection,
  IncreaseSection,
} from "../../MainPage/MainPageStyles";
import { ArrangementSection } from "../Fundamentals/FundamentalsStyles";
import TechnicallAnalysisMainPhoto from "../../../images/techAnalysisMainPhoto.png";
import { NavLink } from "react-router-dom";
import LaptopPhoto from "../../../images/laptop__photo.png";
import WebTerminal from "../../../images/webTerminalPhoto.png";
import { motion } from "framer-motion";
import {
  animationFromTheSide,
  arrAnimation,
  mainAnimation,
} from "../../../animations/animations";
import { MTechnicalAnalisisCard } from "../../../components/Cards/TechnicalAnalisisCard/TechnicalAnalisisCard";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../store/hooks";
import { generateLink } from "../../../functions/routingFuntion";
import { Accordion } from "../../../components/Accordion/Accordion";
import { useState } from "react";

export const TehnicalAnalysis = () => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const language = useAppSelector((state) => state.locale.localStorageValue);
  const { t } = useTranslation();

  const handleToggle = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <main>
      <MainPhotoSection style={{ background: "#074275" }}>
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ amount: 0.3, once: true }}
          className="container__standart flex__between flex__column"
          style={{ marginBottom: "0px" }}
        >
          <motion.div custom={1} variants={arrAnimation}>
            <h1>{t("technicalAnalysisPage.title1")}</h1>
          </motion.div>
          <motion.div custom={2} variants={arrAnimation}>
            <img src={TechnicallAnalysisMainPhoto} alt="#" />
          </motion.div>
        </motion.div>
      </MainPhotoSection>
      <ArrangementSection>
        <div className="container__standart">
          <motion.h2
            initial="hidden"
            whileInView="visible"
            viewport={{ amount: 0.3, once: true }}
            variants={animationFromTheSide}
          >
            {t("technicalAnalysisPage.blockInfo1Tit")}
          </motion.h2>
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ amount: 0.3, once: true }}
            className="arrangement-section__content flex__between"
          >
            <motion.div custom={1} variants={arrAnimation}>
              {t("technicalAnalysisPage.blockInfo11")}
            </motion.div>
            <motion.div custom={2} variants={arrAnimation}>
              {t("technicalAnalysisPage.blockInfo12")}
            </motion.div>
          </motion.div>
        </div>
      </ArrangementSection>
      <WebTerminalSection>
        <div className="container__standart">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ amount: 0.3, once: true }}
            variants={mainAnimation}
            className="flex__between web-terminal__container"
          >
            <div className="web-terminal__info">
              <h2>{t("technicalAnalysisPage.blockInfo2Tit")}</h2>
              <p className="big__text">
                {t("technicalAnalysisPage.blockInfo21")}
              </p>
              <p>{t("technicalAnalysisPage.blockInfo22")}</p>
            </div>
            <div className="web-terminal__photo">
              <div>
                <img src={WebTerminal} alt="WebTerminal" />
              </div>
            </div>
          </motion.div>
          <div
            style={{
              height: "1px",
              margin: "3.75rem 0rem",
              backgroundColor: "#b1b1b1",
            }}
          ></div>
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ amount: 0.3, once: true }}
            className="flex__between flex__wrap"
          >
            <MTechnicalAnalisisCard
              title={`${t("technicalAnalysisPage.blockInfo311")}`}
              text={`${t("technicalAnalysisPage.blockInfo312")}`}
              custom={1}
              variants={arrAnimation}
            />
            <MTechnicalAnalisisCard
              title={`${t("technicalAnalysisPage.blockInfo321")}`}
              text={`${t("technicalAnalysisPage.blockInfo322")}`}
              custom={2}
              variants={arrAnimation}
            />
            <MTechnicalAnalisisCard
              title={`${t("technicalAnalysisPage.blockInfo331")}`}
              text={`${t("technicalAnalysisPage.blockInfo332")}`}
              custom={3}
              variants={arrAnimation}
            />
          </motion.div>
        </div>
      </WebTerminalSection>
      <section>
        <div
          className="container__standart"
          style={{ marginBottom: "3.75rem" }}
        >
          <motion.h2
            initial="hidden"
            whileInView="visible"
            viewport={{ amount: 0.3, once: true }}
            variants={animationFromTheSide}
          >
            {t("technicalAnalysisPage.blockInfo4Tit")}
          </motion.h2>
        </div>
        <div className="container__standart">
          {[
            t("technicalAnalysisPage.blockInfo411"),
            t("technicalAnalysisPage.blockInfo421"),
            t("technicalAnalysisPage.blockInfo431"),
            t("technicalAnalysisPage.blockInfo441"),
            t("technicalAnalysisPage.blockInfo451"),
          ].map((title, index) => (
            <Accordion
              key={index}
              title={title}
              isOpen={activeIndex === index}
              onToggle={() => handleToggle(index)}
            >
              {index === 0 && t("technicalAnalysisPage.blockInfo412")}
              {index === 1 && t("technicalAnalysisPage.blockInfo422")}
              {index === 2 && t("technicalAnalysisPage.blockInfo432")}
              {index === 3 && t("technicalAnalysisPage.blockInfo442")}
              {index === 4 && t("technicalAnalysisPage.blockInfo452")}
            </Accordion>
          ))}
        </div>
      </section>
      <IncreaseSection>
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ amount: 0.3, once: true }}
          className="flex__between container__standart"
        >
          <motion.div
            custom={1}
            variants={arrAnimation}
            className="web-terminal__info"
          >
            <h2>{t("technicalAnalysisPage.blockInfo5Tit")}</h2>
            <NavLink
              className="white__button flex__center"
              to={generateLink("/auth/register", language)}
            >
              {t("technicalAnalysisPage.blockInfo51")}
            </NavLink>
          </motion.div>
          <motion.div
            custom={2}
            variants={arrAnimation}
            className="web-terminal__photo"
          >
            <img src={LaptopPhoto} alt="" />
          </motion.div>
        </motion.div>
      </IncreaseSection>
    </main>
  );
};
